var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemeMakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 685.8 675.2",
    enableBackground: "new 0 0 685.8 675.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M676.8,292.7c-4.2-18.4-7.9-36.8-10.7-55.4l-2-2l-1,21.4c-8.4,0.8-17.9,1.7-25.9-1l-2.1-24.4l-74.9,1 l-1.1,24.5l-25,0.5l-0.1,24.5c-8.5,2.6-17.3,1.4-25.9,0.5v25.5l-26,0.5v25.5c-43.3,0-86.8,2.3-130-1.5l-1-24 c-8.2,0.5-16.4,0.2-24.5-1l-1.5-24c-8.2,0.4-17.5,1.5-24.9-2.6c0,0-1.1-23.4-1.1-23.4c-8.2,0.5-16.4,0.2-24.5-1l-1.5-25l-48.9,1 l-1,24.5l-25,0.5v24.4l-26,1.6v24.5l-26,0.5v25.5l-130,0.5c-4.9,86.9,22.2,179.7,90.5,237l3.4,0.6c11.3,12.8,27.2,21.6,40.5,32.4 c130,77.3,320.7,107.5,447.5,7.1c17.7-16.9,48-33.5,56-57c14.6-22.7,26.8-56.7,29.4-82.4C688.1,412.2,685.9,351.9,676.8,292.7  M105.3,439.3c2.6-2.3,5.6-4.3,8.8-6c13.5,1.3,25.5,9.5,32.6,21c44.2,35.6,96.8,51.8,153.9,44c-0.6-1.7,19.6-5.3,20.1-5.9 c12.1-7.3,35.9-11.3,42.8-24.6c11.4-6,16.9-17.1,20.6-29.4c14.2-8.1,33.7-4.6,39.4,11c-47.9,134.4-273.9,122-327.4,0 C98.8,445.6,101.9,442.3,105.3,439.3 M514.1,35.3c-127.7-72.6-318.5-23.3-415,57c-18.8,17.3-34.1,33.3-49,54 c-10.3,17.2-18.7,37.1-21,57c202.7,0,405.3,0,608,0c1.2,7.7,1.5,16.7,1,26c8.3,0,16.7,0,25,0c-1.6-11.7-7.9-20.5-10.2-31.9 c-3.9-9.4-7.8-18.7-11.8-28.1c-16.3-29.5-33.2-62.2-61-84C568.1,65.1,534.9,49.9,514.1,35.3z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 242,
    className: "st0",
    width: 24.1,
    height: 24.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 267.9,
    className: "st0",
    width: 24.1,
    height: 24.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7,
    y: 294.2,
    className: "st0",
    width: 24.1,
    height: 24.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 336.3,
    y: 242.2,
    className: "st0",
    width: 24.1,
    height: 24.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 361.9,
    y: 268.1,
    className: "st0",
    width: 24.1,
    height: 24.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 294.3,
    className: "st0",
    width: 24.1,
    height: 24.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemeMakerIcon);
export default __webpack_public_path__ + "static/media/meme_maker_icon.b9376773.svg";
export { ForwardRef as ReactComponent };